<template>
  <div :class="classes">
    <span class="products-price__price">{{ item.price }}</span>
    <span class="products-price__sale-price">{{ item.salePrice }}</span>
  </div>
</template>

<script>
// @flow

export default {
  props: {
    item: {
      type: Object, // ChatchampMessageItem
      default: () => {}
    }
  },
  computed: {
    classes () {
      return {
        'products-price': true,
        'products-price--on-sale': !!this.item.salePrice
      }
    }
  }
}
</script>

<style src="./price.scss" />
